import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
interface ProtocoloSectionProps {
  handlePurchase: () => void;
}
export function ProtocoloSection({
  handlePurchase
}: ProtocoloSectionProps) {
  const valueStack = [{
    name: 'Manual Maestro de Abundancia',
    price: '$47',
    desc: 'Guía Neuro-Biológica (60 Pág) + Audios de Meditación 888Hz.'
  }, {
    name: 'BONO #1: The Flow Map 888',
    price: '$20',
    desc: 'Tu GPS diario de riqueza y alineación.'
  }, {
    name: 'BONO #2: La Llave Maestra del Oro Líquido',
    price: '$17',
    desc: '33 Decretos de Poder para abrir flujos bloqueados.'
  }, {
    name: 'BONO #3: Protocolo de Manifestación Acelerada',
    price: '$13',
    desc: 'Técnicas de colapso de tiempo (72 horas).'
  }];
  return <section id="protocolo" aria-label="El protocolo completo - contenido y precio" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-[#0f0f11] relative border-t border-white/5" data-id="element-225">
      <div className="max-w-[1000px] mx-auto" data-id="element-226">
        <div className="bg-dark border border-gold/30 rounded-2xl p-6 sm:p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.1)]" data-id="element-227">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-228">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.6
          }} style={{
            opacity: 1
          }} data-id="element-229">
              <h2 className="font-serif text-3xl md:text-4xl font-black mb-6" data-id="element-230">
                EL PROTOCOLO <br data-id="element-231" />
                <span className="text-gold" data-id="element-232">COMPLETO</span>
              </h2>
              <p className="text-white/85 mb-8" data-id="element-233">
                Todo lo que necesitas para iniciar tu reprogramación
                neuro-cuántica hoy mismo.
              </p>
              <div className="space-y-4 mb-8" data-id="element-234">
                {valueStack.map((item, index) => <div key={index} className="flex items-start gap-3 p-3 rounded-lg bg-white/5 border border-gold/10" data-id="element-235">
                    <CheckCircle2Icon className="w-5 h-5 text-gold shrink-0 mt-1" aria-hidden="true" data-id="element-236" />
                    <div className="flex flex-col" data-id="element-237">
                      <div className="flex justify-between items-center w-full" data-id="element-238">
                        <span className="text-white font-bold text-sm" data-id="element-239">
                          {item.name}
                        </span>
                        <span className="text-gold/50 text-xs line-through" data-id="element-240">
                          {item.price}
                        </span>
                      </div>
                      <span className="text-white/60 text-xs" data-id="element-241">{item.desc}</span>
                    </div>
                  </div>)}
                <div className="pt-4 border-t border-gold/20 flex justify-between items-center font-bold" data-id="element-242">
                  <span className="text-gold text-xs uppercase tracking-tighter" data-id="element-243">
                    Valor Total del Sistema:
                  </span>
                  <span className="text-white line-through" data-id="element-244">$97.00</span>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.6
          }} className="text-center bg-white/5 p-8 rounded-xl border border-white/10" style={{
            opacity: 1
          }} data-id="element-245">
              <div className="mb-6" data-id="element-246">
                <span className="text-5xl font-black text-gold" aria-label="Precio 14 dólares" data-id="element-247">
                  $14
                </span>
              </div>
              <p className="text-sm text-white/75 mb-8" data-id="element-248">
                Pago único. Sin suscripciones ocultas.
              </p>

              <button onClick={handlePurchase} className="bg-gold text-dark border-none py-4 px-6 text-base font-black rounded cursor-pointer transition-all duration-300 shadow-[0_10px_25px_rgba(212,175,55,0.3)] w-full hover:scale-[1.03] hover:bg-[#f1c40f]" data-id="element-249">
                DESCARGAR $14
              </button>

              <div className="mt-6 flex items-center justify-center gap-2 text-white/65 text-xs" data-id="element-250">
                <span aria-label="Compra 100% segura y encriptada" data-id="element-251">
                  🔒 Compra 100% Segura y Encriptada
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}